import { useState, useCallback } from 'react';
import { User } from '../types';

/**
 * Hook personalizado para gestionar el estado del modal de conexión
 * 
 * Controla la visibilidad del modal que aparece cuando dos usuarios
 * hacen match y pueden iniciar una conversación.
 * 
 * @returns Objeto con estado de visibilidad, usuario conectado y funciones de control
 */
export const useConnectionModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [connectedUser, setConnectedUser] = useState<User | null>(null);

  // Mostrar modal de conexión con el usuario especificado
  const showConnection = useCallback((user: User) => {
    setConnectedUser(user);
    setIsVisible(true);
  }, []);

  // Ocultar modal y limpiar usuario conectado
  const hideConnection = useCallback(() => {
    setIsVisible(false);
    setConnectedUser(null);
  }, []);

  return {
    isVisible,
    connectedUser,
    showConnection,
    hideConnection
  };
};